import { products } from '@/mocks/products';
import Reveal from '@/components/base/Reveal';
import { useCatalogVersion } from '@/lib/catalogStore';

export default function NewProducts() {
  useCatalogVersion(); // 데이터 도착 시 재렌더링 트리거
  // catalog is already ordered by created_at desc, so the first 12 are the newest
  const items = products.slice(0, 12);

  return (
    <section className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-24">
        <Reveal>
          <div className="flex items-end justify-between gap-4">
            <div>
              <span className="text-xs font-mono uppercase tracking-[0.25em] text-secondary-500 whitespace-nowrap">
                new arrivals
              </span>
              <h2 className="mt-3 font-display text-3xl md:text-4xl font-normal tracking-tight text-white">
                신규 상품
              </h2>
            </div>
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-5">
          {items.map((product, index) => (
            <Reveal key={product.id} delay={(index % 4) * 60}>
              <a
                href={`/products/${product.id}`}
                className="group block rounded-2xl overflow-hidden bg-background-50 border border-white/5 hover:border-secondary-500/40 transition-all cursor-pointer"
              >
                <div className="relative aspect-square overflow-hidden">
                  <img
                    loading="lazy"
                    decoding="async"
                    src={product.image}
                    alt={product.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />

                  <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full text-xs font-medium bg-secondary-500 text-background-50">
                    신상품
                  </span>

                  <div className="absolute bottom-3 left-3 right-3">
                    <span className="inline-block px-2 py-0.5 rounded-md bg-white/10 backdrop-blur-sm text-[10px] font-medium text-white/80">
                      {product.category}
                    </span>
                  </div>
                </div>

                <div className="p-4">
                  <h3 className="font-heading font-semibold text-foreground-100 group-hover:text-white transition-colors text-sm line-clamp-1">
                    {product.title}
                  </h3>
                  <p className="mt-1 text-xs text-foreground-500 line-clamp-2">
                    {product.description}
                  </p>
                  <div className="mt-3 flex items-center justify-between">
                    <span className="text-sm font-bold text-white">
                      {product.price.toLocaleString()}원
                    </span>
                    <div className="flex items-center gap-1 text-xs text-foreground-400">
                      <i className="ri-star-fill text-primary-400 text-[10px]"></i>
                      <span>{product.rating}</span>
                      <span>({product.reviews})</span>
                    </div>
                  </div>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
